'use client';

import useAutomatedTicketCreation from '@brahma/hooks/use-automated-ticket-creation/useAutomatedTicketCreation';
const AutomatedTicketCreation = () => {
  useAutomatedTicketCreation();
  return null;
};
export default AutomatedTicketCreation;